export default __webpack_public_path__ + "static/media/userjourney6.539d8fe2.png";